import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inputRef", "showError", "value", "onBlur", "onFocus"];
import { memo, useCallback, useMemo, useState } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { domainContainsPath, isValidDomain, getDomainPathInfo, domainContainsProtocol, getDomainProtocolInfo } from '../../validation/PropertyValidations';
import emptyFunction from 'react-utils/emptyFunction';
import { Text } from 'foundations-components/components/Text';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import FormControlAdapter from '../../adapters/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
const ValidationError = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Text, {
    as: "span",
    color: "text-alert-default",
    role: "status",
    children: children
  });
};
const DomainInput = _ref => {
  let {
      inputRef,
      showError,
      value,
      onBlur = emptyFunction,
      onFocus = emptyFunction
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [blurred, setBlurred] = useState(false);
  const propertyValue = value == null ? '' : `${value}`;
  const handleBlur = useCallback(evt => {
    onBlur(evt);
    setBlurred(true);
  }, [onBlur]);
  const handleFocus = useCallback(evt => {
    onFocus(evt);
    setBlurred(false);
  }, [onFocus]);
  const shouldShowError = useMemo(() => showError && blurred && propertyValue && (!isValidDomain(propertyValue) || domainContainsPath(propertyValue) || domainContainsProtocol(propertyValue)), [showError, blurred, propertyValue]);
  const validationError = useMemo(() => {
    if (!shouldShowError) {
      return null;
    }
    const {
      path,
      domain
    } = getDomainPathInfo(propertyValue);
    const {
      protocol
    } = getDomainProtocolInfo(propertyValue);
    if (protocol && path) {
      return /*#__PURE__*/_jsx(ValidationError, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataProperties.PropertyDomain.error.invalidDomainBoth",
          options: {
            domain,
            protocol,
            path
          }
        })
      });
    }
    if (protocol) {
      return /*#__PURE__*/_jsx(ValidationError, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataProperties.PropertyDomain.error.invalidProtocol",
          options: {
            domain,
            protocol
          }
        })
      });
    }
    if (path) {
      return /*#__PURE__*/_jsx(ValidationError, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataProperties.PropertyDomain.error.invalidPath",
          options: {
            domain,
            path
          }
        })
      });
    }
    return /*#__PURE__*/_jsx(ValidationError, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "customerDataProperties.PropertyDomain.error.invalidDomain",
        options: {
          domain: propertyValue
        }
      })
    });
  }, [shouldShowError, propertyValue]);
  return /*#__PURE__*/_jsx(FormControlAdapter, {
    error: !!shouldShowError,
    validationMessage: validationError,
    children: /*#__PURE__*/_jsx(TextInput, Object.assign({}, rest, {
      inputRef: inputRef,
      value: propertyValue,
      onBlur: handleBlur,
      onFocus: handleFocus
    }))
  });
};
export default /*#__PURE__*/memo(DomainInput);